import React from 'react';
import Container from '../../../components/Container';
import { Modal, View } from 'react-native';
import EquipmentCategoryDropdown from '../../../components/dispatch/EquipmentCategoryDropdown';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../../../services/window-information';
import FormActions from '../../../components/FormActions';
import FormInput from '../../../components/FormInput';
import { translate } from '../../../services/translate';
import { SimplifiedEquipments } from '../../../services/central-api/dispatch';
import { useForm, UseFormReturn } from 'react-hook-form';
import { UnitValuesForm } from './UnitForm';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    externalForm: UseFormReturn<UnitValuesForm, any, any>;
    selectableEquipments: SimplifiedEquipments[];
    onClose: () => void;
    actingBodyId: number;
}

export interface EquipmentByCategoryForm {
    equipmentCategory: number;
    quantity: number;
    maxValue: number;
}

export default function AddEquipmentByCategoryModal({ externalForm, isModalVisible, onClose, setModalVisible, actingBodyId, selectableEquipments }: ModalProps) {
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const defaultEmptyValues: EquipmentByCategoryForm = {
        equipmentCategory: 0,
        quantity: 1,
        maxValue: 1000,
    };

    const form = useForm<EquipmentByCategoryForm>({
        defaultValues: defaultEmptyValues,
        mode: 'onChange'
    });

    function formSubmit() {
        const equipments = selectableEquipments
            .filter(e => !externalForm.watch('equipments').includes(e.id))
            .filter(e => e.equipmentCategoryId === form.watch('equipmentCategory'))
            .slice(0, form.watch('quantity'))
            .map(e => e.id);

        externalForm.setValue('equipments', [...externalForm.watch('equipments'), ...equipments]);
        clearValues();
        onClose();
    }

    function clearValues() {
        form.reset(defaultEmptyValues);
    }

    return (
        <Modal
            transparent={true}
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                setModalVisible(false);
                clearValues();
                onClose();
            }}
        >
            <Container style={styles.container}>
                <View style={[styles.formContainer, windowInfo.isMobile ? { width: '95%' } : { width: '35%' }]}>
                    <EquipmentCategoryDropdown
                        actingBodyId={actingBodyId}
                        form={form}
                        fieldName='equipmentCategory'
                        fieldMaxValue='maxValue'
                        zIndex={2}
                        removeItemsWithoutSlots
                        selectableEquipments={selectableEquipments}
                    />
                    <FormInput
                        label={translate('quantity')}
                        form={form}
                        fieldName='quantity'
                        minValue={1}
                        required={true}
                        maxValue={form.watch('maxValue')}
                        mode='NUMBER'
                    />
                    <FormActions
                        onSubmit={formSubmit}
                        confirmText='addEquipment'
                        onClose={() => {
                            clearValues();
                            onClose();
                        }}
                        disabled={!form.formState.isValid}
                    />
                </View>
            </Container>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    formContainer: {
        minWidth: 300,
        minHeight: 150,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        padding: 20,
        rowGap: 25
    },
}));
